import { getUpgradeData } from "libs/item";
import { ItemText } from "./ItemBase";

const ItemName = ({ slug }: { slug: string }) => {
  const upgrade = getUpgradeData(slug) || null;

  if (!!upgrade) {
    return (
      <ItemText
        color={upgrade.gradeData.color}
        colorSecondary={upgrade.gradeData.colorSecondary}
      >
        {upgrade.name}
      </ItemText>
    );
  }

  return <></>;
};

export default ItemName;
